﻿import {currentCulture, NamedValue, TimeOnly} from "@2d-front-monorepo/core";

export default function createTimeRange(start: TimeOnly | undefined = undefined, end: TimeOnly | undefined = undefined): NamedValue<TimeOnly>[] {
	const culture = currentCulture();
	const result: NamedValue<TimeOnly>[] = [];
	const startHour = start == null ? 0 : start.getHours();
	const endHour = end == null ? 23 : end.getHours();

	if (endHour < startHour) throw new Error(
		`End hour must be greater than start hour. Start hour: ${startHour}, end hour: ${endHour}`
	);

	for (let i = startHour; i <= endHour; i++) {
		const time = TimeOnly.fromComponents(i, 0, 0);
		result.push({label: culture.formatTime(time, "short-time"), value: time});
	}

	if (end == null) {
		const time = TimeOnly.endOfDay();
		result.push({label: culture.formatTime(time, "short-time"), value: time});
	}

	return result;
}
